// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export function getShipToStateByCustomerSequence(state: ApplicationState, customerSequence: string | undefined) {
    return Object.values(state.data.shipTos.byId).find(x => x.customerSequence === customerSequence);
}
